<style>
.loading-box {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}
</style>
<template>
    <div v-if="loading" class="loading-box">
        <van-loading />
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            loading: false
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/api/loading.vue